<template>
  <!-- Faded stand-ins for the ranked ads, creative velocity and creator partnership previews, for brands with no ad data yet.
    Each panel keeps the size of the preview it stands in for, so swapping from BrandOverviewView's loading state doesn't shift the page -->
  <div class="w-full flex flex-col gap-4 pointer-events-none select-none">
    <!-- Top Ranked Ads (AdRankPreview) -->
    <div class="ad-rank-panel w-full flex flex-col px-1 pt-1 pb-3 bg-white border border-border-normal overflow-hidden">
      <div class="ad-rank-header flex items-center gap-2 px-2 opacity-40">
        <div class="flex items-center gap-1 p-1">
          <AdRankIcon class="text-icon-normal flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-muted whitespace-nowrap">
            Top Ranked Ads
          </BaseText>
        </div>
        <div class="flex items-center gap-1 p-1">
          <EvergreenIcon class="text-text-subdued flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-subdued whitespace-nowrap">
            Evergreen Winners
          </BaseText>
        </div>
        <div class="flex items-center gap-1 p-1">
          <BreakoutIcon class="text-text-subdued flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-subdued whitespace-nowrap">
            Breakouts
          </BaseText>
        </div>
      </div>
      <div class="ad-cards-row w-full flex gap-1 bg-neutral-25 opacity-40 overflow-hidden">
        <div v-for="i in 8" :key="`ad-card-skeleton-${i}`" class="ad-card flex-shrink-0 bg-white" />
      </div>
    </div>
    <!-- Creative Velocity (CreativeVelocity) -->
    <div class="skeleton-panel w-full flex flex-col gap-1 p-1 bg-white border border-border-normal overflow-hidden">
      <div class="velocity-header flex items-center gap-1 px-3 opacity-40">
        <CreativeVelocityIcon class="text-icon-normal flex-shrink-0" />
        <BaseText type="label" size="sm" class="text-text-muted whitespace-nowrap">
          Meta Creative Velocity
        </BaseText>
      </div>
      <div class="w-full flex gap-2 px-1 pb-1 opacity-40">
        <div v-for="i in 4" :key="`velocity-count-skeleton-${i}`" class="velocity-count flex-1 min-w-0 bg-neutral-25" />
      </div>
      <!-- Blank where the graph's legend and graph go -->
      <div class="velocity-graph w-full" />
    </div>
    <!-- Creator Partnerships (CreatorPartnershipsPreview) -->
    <div class="skeleton-panel w-full flex flex-col gap-1 p-1 bg-white border border-border-normal overflow-hidden">
      <div class="flex items-center p-2 opacity-40">
        <div class="flex items-center gap-2 p-1">
          <CreatorPartnershipIcon class="text-icon-normal flex-shrink-0" />
          <BaseText type="label" size="sm" class="text-text-muted whitespace-nowrap">
            Creator Partnerships
          </BaseText>
        </div>
      </div>
      <!-- Partnership split and creator list -->
      <div class="partnerships-row w-full grid gap-1 p-1 bg-neutral-25 opacity-40">
        <div class="partnerships-card bg-white" />
        <div class="partnerships-card bg-white" />
      </div>
    </div>
  </div>
</template>

<script>
import AdRankIcon from '../../../globals/Icons/SpyderModeIcons/AdRankIcon.vue'
import BreakoutIcon from '../../../globals/Icons/SpyderV2Icons/BreakoutIcon.vue'
import CreativeVelocityIcon from '../../../globals/Icons/SpyderV2Icons/CreativeVelocityIcon.vue'
import CreatorPartnershipIcon from '../../../globals/Icons/SpyderV2Icons/CreatorPartnershipIcon.vue'
import EvergreenIcon from '../../../globals/Icons/SpyderV2Icons/EvergreenIcon.vue'

export default {
  name: 'TrackBrandPreviewsSkeleton',
  components: {
    AdRankIcon,
    BreakoutIcon,
    CreativeVelocityIcon,
    CreatorPartnershipIcon,
    EvergreenIcon
  }
}
</script>

<style scoped>
.skeleton-panel {
  border-radius: 20px;
}
.ad-card, .partnerships-card {
  border-radius: 12px;
  box-shadow: 0px 6px 12px -3px rgba(26, 35, 66, 0.04), 0px 2px 4px -1.5px rgba(26, 35, 66, 0.04), 0px 1px 2px -0.75px rgba(26, 35, 66, 0.04);
}

/* Sizes below are the previews' own, so the panels line up with them */

/* AdRankPreview */
.ad-rank-panel {
  border-radius: 20px 20px 8px 8px;
}
.ad-rank-header {
  /* Its tabs and bordered scroll buttons, in 8px of padding */
  height: 46px;
}
.ad-cards-row {
  height: 368px;
  padding: 6px 6px 0;
  border-radius: 16px;
}
.ad-card {
  width: 260px;
  height: 358px;
}

/* CreativeVelocity */
.velocity-header {
  /* Its lookback toggle, in 12px of padding */
  height: 52px;
}
.velocity-count {
  height: 68px;
  border-radius: 10px;
}
.velocity-graph {
  /* Legend (28px), the panel's 4px gap, then the graph (348px) */
  height: 380px;
}

/* CreatorPartnershipsPreview */
.partnerships-row {
  grid-template-columns: 224px 1fr;
  height: 244px;
  border-radius: 14px;
}
</style>
